export default {"src":"/_next/static/media/shift.a37ed505.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};